import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

// Assets
import EmptyImage from "assets/images/empty_image.png";

// Components
import CenterPageTemplate from "../CenterPageTemplate";
import Text from "new_components/atoms/Text";
import AILogo from "new_components/molecules/AILogo";

// Constants
import colors from "styles/colors";
import typography from "styles/typography";

const EmptyStateImage = styled.img`
  max-width: 180px;
  height: auto;
`;

const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 500px;
`;

const EmptyTemplate = ({
  pageTitle,
  emptyText,
  actionRow,
}) => {
  return (
    <CenterPageTemplate>
      <Text
        typographyStyle={typography.display.bold}
        color={colors.text.black}
      >
        {pageTitle}
      </Text>
      <DescriptionContainer>
        <Text
          typographyStyle={typography.body.regular}
          color={colors.text.gray}
        >
          {emptyText}
        </Text>
        {actionRow && actionRow}
      </DescriptionContainer>
    </CenterPageTemplate>
  );
};

EmptyTemplate.propTypes = {
  pageTitle: PropTypes.string, // Page title for the base layout
  emptyText: PropTypes.string, // Text to display when the content is empty
  actionRow: PropTypes.node, // Optional action row to display
};

export default EmptyTemplate;
